{
  "id": "provisional-u11",
  "version": 1,
  "reviewStatus": "provisional",
  "entries": [
    {
      "id": "GK_BUILD_01",
      "role": "GK",
      "category": "on_ball",
      "phase": "build_up",
      "title": "Distribution with time",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "nearestOppDist",
            "op": ">=",
            "v": 12
          }
        ]
      },
      "cues": [
        "Where are their forwards standing?",
        "Which full back is free?",
        "Is there space behind their line?"
      ],
      "actions": [
        {
          "id": "keeper_short",
          "label": "Build short",
          "intent": "keeper_distribute_short",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": 0.3,
              "why": "no press: build from the back"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": 0.3,
              "why": "short options are open"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "<=",
                  "v": 1
                }
              ],
              "add": -0.3,
              "why": "short options are covered"
            }
          ]
        },
        {
          "id": "keeper_long",
          "label": "Go long",
          "intent": "keeper_distribute_long",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "<=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "short options are covered"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 15
                }
              ],
              "add": 0.2,
              "why": "space behind their line"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.2,
              "why": "no press: a long ball gives possession away"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        }
      ],
      "mistakes": [
        "Kicking long every time regardless of the press",
        "Playing short into a covered full back"
      ],
      "difficultyFactors": [
        "Number of free short options",
        "Depth of their line"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Team builds from the back or contests a long ball.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "nearestOppDist": 20
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "nearestOppDist": 6
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_BUILD_02",
      "role": "GK",
      "category": "on_ball",
      "phase": "build_up",
      "title": "Play through the press",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "nearestOppDist",
            "op": "<",
            "v": 12
          },
          {
            "f": "openLanes",
            "op": ">=",
            "v": 2
          }
        ]
      },
      "cues": [
        "Who is pressing and from where?",
        "Which short lane is still open?",
        "Is the long option worth the risk?"
      ],
      "actions": [
        {
          "id": "keeper_short",
          "label": "Build short",
          "intent": "keeper_distribute_short",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": 0.3,
              "why": "no press: build from the back"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": 0.3,
              "why": "short options are open"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "<=",
                  "v": 1
                }
              ],
              "add": -0.3,
              "why": "short options are covered"
            }
          ]
        },
        {
          "id": "keeper_long",
          "label": "Go long",
          "intent": "keeper_distribute_long",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "<=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "short options are covered"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 15
                }
              ],
              "add": 0.2,
              "why": "space behind their line"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.2,
              "why": "no press: a long ball gives possession away"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        }
      ],
      "mistakes": [
        "Forcing a short pass into the presser's path",
        "Holding until the presser arrives"
      ],
      "difficultyFactors": [
        "Speed of the press",
        "Open lanes remaining"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Possession kept short, contested long, or lost near goal.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "nearestOppDist": 7,
              "openLanes": 2
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "nearestOppDist": 15,
              "openLanes": 2
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_BUILD_03",
      "role": "GK",
      "category": "on_ball",
      "phase": "build_up",
      "title": "Pressed with the short lanes shut",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "nearestOppDist",
            "op": "<",
            "v": 12
          },
          {
            "f": "openLanes",
            "op": "<=",
            "v": 1
          }
        ]
      },
      "cues": [
        "Are the full backs marked?",
        "Who is free two lines up?",
        "Is a switch to the far side on?"
      ],
      "actions": [
        {
          "id": "keeper_skip_lines",
          "label": "Skip the press: find the far midfielder",
          "intent": "keeper_distribute_long",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "<=",
                  "v": 1
                },
                {
                  "f": "nearestOppDist",
                  "op": "<",
                  "v": 12
                }
              ],
              "add": 0.4,
              "why": "they press high and the short lanes are shut: play over them"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 10
                }
              ],
              "add": -0.2,
              "why": "their line is deep: the long ball lands in a crowd"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "keeper_short",
          "label": "Build short",
          "intent": "keeper_distribute_short",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": 0.3,
              "why": "no press: build from the back"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": 0.3,
              "why": "short options are open"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "<=",
                  "v": 1
                }
              ],
              "add": -0.3,
              "why": "short options are covered"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        }
      ],
      "mistakes": [
        "Forcing the ball into a marked full back",
        "Hoofing it aimlessly when a far-side midfielder is free"
      ],
      "difficultyFactors": [
        "Distance to the presser",
        "Depth of their line"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Press skipped into midfield, or the ball is contested or lost.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "nearestOppDist": 7,
              "openLanes": 0
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "nearestOppDist": 7,
              "openLanes": 3
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_TRANS_01",
      "role": "GK",
      "category": "transition",
      "phase": "transition",
      "title": "Ball just claimed: restart the attack",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 4
          },
          {
            "f": "spaceBehindLine",
            "op": ">",
            "v": 20
          },
          {
            "f": "nearestOppDist",
            "op": ">=",
            "v": 6
          }
        ]
      },
      "cues": [
        "Are they still pushed up?",
        "Which teammate is already facing forward?",
        "Is quick better than safe right now?"
      ],
      "actions": [
        {
          "id": "keeper_long",
          "label": "Go long",
          "intent": "keeper_distribute_long",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "<=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "short options are covered"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 15
                }
              ],
              "add": 0.2,
              "why": "space behind their line"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.2,
              "why": "no press: a long ball gives possession away"
            }
          ]
        },
        {
          "id": "keeper_short",
          "label": "Build short",
          "intent": "keeper_distribute_short",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": 0.3,
              "why": "no press: build from the back"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": 0.3,
              "why": "short options are open"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "<=",
                  "v": 1
                }
              ],
              "add": -0.3,
              "why": "short options are covered"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        }
      ],
      "mistakes": [
        "Slowing the game down when they are stretched",
        "Kicking it straight back to them"
      ],
      "difficultyFactors": [
        "Opponent recovery speed",
        "Space behind their line"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter launched, possession settled, or the ball given straight back.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 1,
              "spaceBehindLine": 26,
              "nearestOppDist": 10
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 1,
              "spaceBehindLine": 12,
              "nearestOppDist": 10
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_POS_01",
      "role": "GK",
      "category": "off_ball",
      "phase": "build_up",
      "title": "Team building in front of you",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballProgress",
            "op": "<",
            "v": 0.5
          },
          {
            "f": "teammateCarrierDist",
            "op": "<",
            "v": 35
          },
          {
            "f": "secondsSinceTurnover",
            "op": ">=",
            "v": 5
          }
        ]
      },
      "cues": [
        "Is the carrier under pressure?",
        "Can they see you as the free player?",
        "Where is their striker standing?"
      ],
      "actions": [
        {
          "id": "keeper_outlet",
          "label": "Offer the outlet",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier is pressed: they need you as the free player"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: stay home and keep the goal covered"
            },
            {
              "when": [
                {
                  "f": "teammateCarrierDist",
                  "op": ">",
                  "v": 30
                }
              ],
              "add": -0.3,
              "why": "too far from the ball to be a real option"
            }
          ]
        },
        {
          "id": "keeper_set",
          "label": "Stay set, goal covered",
          "intent": "keeper_hold_line",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 22
                }
              ],
              "add": 0.3,
              "why": "a shot can come any moment: be set"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is going behind: be ready for the ball in"
            },
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": ">",
                  "v": 22
                },
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 30
                }
              ],
              "add": -0.3,
              "why": "the line is high and the ball is far: you could start higher"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                },
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet"
            }
          ]
        },
        {
          "id": "keeper_organise",
          "label": "Organise the line",
          "intent": "communicate",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 0
                },
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "nobody is on the carrier: tell the line who goes"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is behind the line: call it early"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 16
                }
              ],
              "add": -0.4,
              "why": "too late to talk: the shot is coming"
            },
            {
              "when": [
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                },
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet, not instructions"
            }
          ]
        }
      ],
      "mistakes": [
        "Hiding behind the striker when the carrier is pressed",
        "Wandering off the line while the ball is still in our half"
      ],
      "difficultyFactors": [
        "Carrier pressure",
        "Striker position"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Back pass used, team progresses, or the ball is lost near your goal.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballProgress": 0.3,
              "teammateCarrierDist": 20,
              "secondsSinceTurnover": 30
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballProgress": 0.7,
              "teammateCarrierDist": 20,
              "secondsSinceTurnover": 30
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_POS_02",
      "role": "GK",
      "category": "off_ball",
      "phase": "progression",
      "title": "Team attacking: pick your starting position",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballProgress",
            "op": ">=",
            "v": 0.5
          },
          {
            "f": "secondsSinceTurnover",
            "op": ">=",
            "v": 5
          }
        ]
      },
      "cues": [
        "How high is your back line?",
        "How much space is behind it?",
        "Who is their quickest forward?"
      ],
      "actions": [
        {
          "id": "keeper_step_up",
          "label": "Start high, sweep behind the line",
          "intent": "keeper_step_up",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": 0.4,
              "why": "your line is high: the space behind is yours to cover"
            },
            {
              "when": [
                {
                  "f": "ballProgress",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.2,
              "why": "the ball is far away: you have time to get back"
            },
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": -0.4,
              "why": "the line is deep: there is no space behind it to sweep"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 22
                }
              ],
              "add": -0.5,
              "why": "they are already close: coming out opens the goal"
            }
          ]
        },
        {
          "id": "keeper_set",
          "label": "Stay set, goal covered",
          "intent": "keeper_hold_line",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 22
                }
              ],
              "add": 0.3,
              "why": "a shot can come any moment: be set"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is going behind: be ready for the ball in"
            },
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": ">",
                  "v": 22
                },
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 30
                }
              ],
              "add": -0.3,
              "why": "the line is high and the ball is far: you could start higher"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                },
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet"
            }
          ]
        },
        {
          "id": "keeper_organise",
          "label": "Organise the line",
          "intent": "communicate",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 0
                },
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "nobody is on the carrier: tell the line who goes"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is behind the line: call it early"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 16
                }
              ],
              "add": -0.4,
              "why": "too late to talk: the shot is coming"
            },
            {
              "when": [
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                },
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet, not instructions"
            }
          ]
        }
      ],
      "mistakes": [
        "Standing on the line with the defence at halfway",
        "Coming so far out a long ball beats you"
      ],
      "difficultyFactors": [
        "Height of the back line",
        "Distance of the ball"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Attack continues, or the ball turns over and your start position decides the counter.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballProgress": 0.7,
              "ourLineDepth": 28,
              "secondsSinceTurnover": 30
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballProgress": 0.3,
              "ourLineDepth": 28,
              "secondsSinceTurnover": 30
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_LINE_01",
      "role": "GK",
      "category": "defending",
      "phase": "defending",
      "title": "They have it in midfield",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDistToOurGoal",
            "op": ">=",
            "v": 22
          },
          {
            "f": "carrierDistToOurGoal",
            "op": "<",
            "v": 45
          },
          {
            "f": "secondsSinceTurnover",
            "op": ">=",
            "v": 5
          }
        ]
      },
      "cues": [
        "Is anyone pressing the carrier?",
        "Is a runner going behind your line?",
        "How much space is between the line and you?"
      ],
      "actions": [
        {
          "id": "keeper_organise",
          "label": "Organise the line",
          "intent": "communicate",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 0
                },
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "nobody is on the carrier: tell the line who goes"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is behind the line: call it early"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 16
                }
              ],
              "add": -0.4,
              "why": "too late to talk: the shot is coming"
            },
            {
              "when": [
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                },
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet, not instructions"
            }
          ]
        },
        {
          "id": "keeper_step_up",
          "label": "Start high, sweep behind the line",
          "intent": "keeper_step_up",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": 0.4,
              "why": "your line is high: the space behind is yours to cover"
            },
            {
              "when": [
                {
                  "f": "ballProgress",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.2,
              "why": "the ball is far away: you have time to get back"
            },
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": -0.4,
              "why": "the line is deep: there is no space behind it to sweep"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 22
                }
              ],
              "add": -0.5,
              "why": "they are already close: coming out opens the goal"
            }
          ]
        },
        {
          "id": "keeper_set",
          "label": "Stay set, goal covered",
          "intent": "keeper_hold_line",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 22
                }
              ],
              "add": 0.3,
              "why": "a shot can come any moment: be set"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is going behind: be ready for the ball in"
            },
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": ">",
                  "v": 22
                },
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 30
                }
              ],
              "add": -0.3,
              "why": "the line is high and the ball is far: you could start higher"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                },
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet"
            }
          ]
        }
      ],
      "mistakes": [
        "Silent while the line is disorganised",
        "Retreating to the line when the space behind the defence is yours"
      ],
      "difficultyFactors": [
        "Runner presence",
        "Line height"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Attack slowed, ball in behind swept, or the carrier progresses.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDistToOurGoal": 32,
              "secondsSinceTurnover": 30
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDistToOurGoal": 15,
              "secondsSinceTurnover": 30
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_CROSS_01",
      "role": "GK",
      "category": "defending",
      "phase": "defending",
      "title": "Ball wide near your box",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDistToOurGoal",
            "op": "<",
            "v": 30
          },
          {
            "f": "ballWide",
            "op": ">",
            "v": 0.55
          }
        ]
      },
      "cues": [
        "Can they shoot from there or only cross?",
        "Who is at your far post?",
        "Is your defender showing them outside?"
      ],
      "actions": [
        {
          "id": "keeper_near_post",
          "label": "Protect the near post",
          "intent": "keeper_near_post",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "ballWide",
                  "op": ">",
                  "v": 0.7
                },
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 18
                }
              ],
              "add": 0.5,
              "why": "the ball is wide and close: the near post is the first shot"
            },
            {
              "when": [
                {
                  "f": "ballWide",
                  "op": "<",
                  "v": 0.6
                }
              ],
              "add": -0.4,
              "why": "the ball is central: leaving the middle opens the far side"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.3,
              "why": "too early: a cross from there needs you central"
            }
          ]
        },
        {
          "id": "keeper_set",
          "label": "Stay set, goal covered",
          "intent": "keeper_hold_line",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 22
                }
              ],
              "add": 0.3,
              "why": "a shot can come any moment: be set"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is going behind: be ready for the ball in"
            },
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": ">",
                  "v": 22
                },
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 30
                }
              ],
              "add": -0.3,
              "why": "the line is high and the ball is far: you could start higher"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                },
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet"
            }
          ]
        },
        {
          "id": "keeper_organise",
          "label": "Organise the line",
          "intent": "communicate",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 0
                },
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "nobody is on the carrier: tell the line who goes"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is behind the line: call it early"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 16
                }
              ],
              "add": -0.4,
              "why": "too late to talk: the shot is coming"
            },
            {
              "when": [
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                },
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet, not instructions"
            }
          ]
        }
      ],
      "mistakes": [
        "Hugging the near post for a ball that is going to be crossed",
        "Standing central when the shot from the angle is on"
      ],
      "difficultyFactors": [
        "Angle of the ball",
        "Distance to goal"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Shot from the angle, cross delivered, or the ball is delayed.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDistToOurGoal": 16,
              "ballWide": 0.8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDistToOurGoal": 16,
              "ballWide": 0.2
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_1V1_01",
      "role": "GK",
      "category": "defending",
      "phase": "defending",
      "title": "One against one",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDistToOurGoal",
            "op": "<",
            "v": 16
          },
          {
            "f": "teammatePressing",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballWide",
            "op": "<=",
            "v": 0.55
          }
        ]
      },
      "cues": [
        "How far away are they?",
        "Are they looking at the ball or at you?",
        "Is a defender recovering?"
      ],
      "actions": [
        {
          "id": "keeper_come_out",
          "label": "Come out and close them down",
          "intent": "press",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 9
                }
              ],
              "add": 0.4,
              "why": "close enough to smother before they set the shot"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a defender is on them: stay big on your line"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.4,
              "why": "too far: you would be stranded halfway"
            }
          ]
        },
        {
          "id": "keeper_stay_big",
          "label": "Stay big, make them beat you",
          "intent": "keeper_hold_line",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a defender is delaying them: hold and be set"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.2,
              "why": "they are not close enough to smother"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 7
                },
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.3,
              "why": "they are alone and close: standing still gives them the angle"
            }
          ]
        },
        {
          "id": "keeper_narrow",
          "label": "Narrow the angle, stay up",
          "intent": "delay",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": ">=",
                  "v": 7
                },
                {
                  "f": "carrierDist",
                  "op": "<=",
                  "v": 12
                }
              ],
              "add": 0.4,
              "why": "mid range: take a step out and take the angle away"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.3,
              "why": "a runner is square: leaving the line opens the pass"
            }
          ]
        }
      ],
      "mistakes": [
        "Diving in early and being rounded",
        "Staying rooted while they walk it closer"
      ],
      "difficultyFactors": [
        "Carrier distance",
        "Recovering defenders"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Ball smothered, shot faced, or the attacker goes past.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDistToOurGoal": 10,
              "carrierDist": 8,
              "teammatePressing": 0,
              "ballWide": 0.2
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDistToOurGoal": 10,
              "carrierDist": 8,
              "teammatePressing": 1,
              "ballWide": 0.2
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_TRANS_02",
      "role": "GK",
      "category": "transition",
      "phase": "transition",
      "title": "Ball lost upfield: reset your start",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 5
          },
          {
            "f": "carrierDistToOurGoal",
            "op": ">",
            "v": 25
          },
          {
            "f": "ourLineDepth",
            "op": ">",
            "v": 18
          }
        ]
      },
      "cues": [
        "Is your line still high?",
        "Where is their quickest forward?",
        "Who is recovering?"
      ],
      "actions": [
        {
          "id": "keeper_step_up",
          "label": "Start high, sweep behind the line",
          "intent": "keeper_step_up",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": 0.4,
              "why": "your line is high: the space behind is yours to cover"
            },
            {
              "when": [
                {
                  "f": "ballProgress",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.2,
              "why": "the ball is far away: you have time to get back"
            },
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": -0.4,
              "why": "the line is deep: there is no space behind it to sweep"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 22
                }
              ],
              "add": -0.5,
              "why": "they are already close: coming out opens the goal"
            }
          ]
        },
        {
          "id": "keeper_set",
          "label": "Stay set, goal covered",
          "intent": "keeper_hold_line",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 22
                }
              ],
              "add": 0.3,
              "why": "a shot can come any moment: be set"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is going behind: be ready for the ball in"
            },
            {
              "when": [
                {
                  "f": "ourLineDepth",
                  "op": ">",
                  "v": 22
                },
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 30
                }
              ],
              "add": -0.3,
              "why": "the line is high and the ball is far: you could start higher"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                },
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet"
            }
          ]
        },
        {
          "id": "keeper_organise",
          "label": "Organise the line",
          "intent": "communicate",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 0
                },
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "nobody is on the carrier: tell the line who goes"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a runner is behind the line: call it early"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 16
                }
              ],
              "add": -0.4,
              "why": "too late to talk: the shot is coming"
            },
            {
              "when": [
                {
                  "f": "ourPossession",
                  "op": "==",
                  "v": 1
                },
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "your teammate needed an outlet, not instructions"
            }
          ]
        }
      ],
      "mistakes": [
        "Dropping to the line and leaving 20 metres in front of you",
        "Freezing while the defence sprints back"
      ],
      "difficultyFactors": [
        "Line height at the turnover",
        "Counter speed"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter swept up, delayed, or a ball in behind arrives.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "secondsSinceTurnover": 2,
              "carrierDistToOurGoal": 40,
              "ourLineDepth": 30
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "secondsSinceTurnover": 2,
              "carrierDistToOurGoal": 40,
              "ourLineDepth": 12
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_SWEEP_01",
      "role": "GK",
      "category": "defending",
      "phase": "defending",
      "title": "Ball played in behind",
      "trigger": {
        "all": [
          {
            "f": "looseBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "ballInOurBox",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          }
        ]
      },
      "cues": [
        "Who reaches the ball first?",
        "Where is the nearest attacker?",
        "Can a defender clear instead?"
      ],
      "actions": [
        {
          "id": "keeper_sweep",
          "label": "Come and claim",
          "intent": "keeper_sweep",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "keeperCanSweep",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.6,
              "why": "you reach it before any attacker"
            },
            {
              "when": [
                {
                  "f": "keeperCanSweep",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.6,
              "why": "an attacker gets there first: stay"
            }
          ]
        },
        {
          "id": "keeper_hold_line",
          "label": "Stay set",
          "intent": "keeper_hold_line",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "keeperCanSweep",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "the ball is not yours to claim"
            },
            {
              "when": [
                {
                  "f": "keeperCanSweep",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "the ball was there to be claimed"
            }
          ]
        }
      ],
      "mistakes": [
        "Coming late and getting stranded",
        "Staying rooted when the ball is yours"
      ],
      "difficultyFactors": [
        "Arrival-time margin",
        "Attacker proximity"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Keeper claims, defender clears, or attacker reaches it first.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "looseBall": 1,
              "ballInOurBox": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "looseBall": 1,
              "ballInOurBox": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_SHOT_01",
      "role": "GK",
      "category": "defending",
      "phase": "defending",
      "title": "Attacker closing on goal, defender on them",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDistToOurGoal",
            "op": "<",
            "v": 22
          },
          {
            "f": "teammatePressing",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Is the shot angle open?",
        "Is the defender delaying them or diving in?",
        "Can you narrow the angle safely?"
      ],
      "actions": [
        {
          "id": "keeper_hold_line",
          "label": "Stay set",
          "intent": "keeper_hold_line",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "keeperCanSweep",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "the ball is not yours to claim"
            },
            {
              "when": [
                {
                  "f": "keeperCanSweep",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "the ball was there to be claimed"
            }
          ]
        },
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "communicate",
          "label": "Communicate and hand off",
          "intent": "communicate",
          "base": 0.2,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a teammate has the carrier, organise around them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.3,
              "why": "you were the closest: act, then talk"
            }
          ]
        }
      ],
      "mistakes": [
        "Rushing out and opening the far post",
        "Standing still with no defender delaying"
      ],
      "difficultyFactors": [
        "Carrier speed",
        "Cover available"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Shot, block, or the carrier is delayed.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDistToOurGoal": 15,
              "carrierDist": 10,
              "teammatePressing": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDistToOurGoal": 40
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "GK_RECV_01",
      "role": "GK",
      "category": "on_ball",
      "phase": "build_up",
      "title": "Back pass under pressure",
      "trigger": {
        "all": [
          {
            "f": "receiving",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Which side is the presser coming from?",
        "Where is your free defender?"
      ],
      "actions": [
        {
          "id": "touch_safe",
          "label": "Safe touch away from pressure",
          "intent": "first_touch_safe",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "pressure is arriving: protect the ball first"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space ahead went unused"
            }
          ]
        },
        {
          "id": "touch_forward",
          "label": "First touch forward",
          "intent": "first_touch_forward",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "space to turn into"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.5,
              "why": "a defender arrives as the ball does"
            }
          ]
        }
      ],
      "mistakes": [
        "Touching toward the presser",
        "Taking too many touches"
      ],
      "difficultyFactors": [
        "Pressure at receipt",
        "Pass quality"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Keeper controls and distributes or is pressed into an error.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "receiving": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "receiving": 0,
              "hasBall": 1
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CB_BUILD_01",
      "role": "CB",
      "category": "on_ball",
      "phase": "build_up",
      "title": "On the ball with time in build-up",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": "<",
            "v": 0.45
          },
          {
            "f": "pressure",
            "op": "<",
            "v": 0.5
          }
        ]
      },
      "cues": [
        "Which midfielder is between the lines?",
        "Is the far side open?",
        "Can you carry into midfield?"
      ],
      "actions": [
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        }
      ],
      "mistakes": [
        "Passing sideways when a forward lane is open",
        "Carrying into a crowd"
      ],
      "difficultyFactors": [
        "Number of open lanes",
        "Distance to the nearest presser"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Team progresses through midfield or resets.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.3,
              "pressure": 0.2
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.3,
              "pressure": 0.8
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CB_BUILD_02",
      "role": "CB",
      "category": "on_ball",
      "phase": "build_up",
      "title": "Pressed in your own half",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": "<",
            "v": 0.5
          },
          {
            "f": "pressure",
            "op": ">=",
            "v": 0.5
          }
        ]
      },
      "cues": [
        "Where is the pressure coming from?",
        "Who is the safe outlet?",
        "Is there a gap behind the presser?"
      ],
      "actions": [
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        }
      ],
      "mistakes": [
        "Dribbling out of pressure near your own goal",
        "Holding until the tackle"
      ],
      "difficultyFactors": [
        "Pressure",
        "Time to decide"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Pressure escaped or turnover near goal.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.3,
              "pressure": 0.8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.3,
              "pressure": 0.2
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CB_DEF_01",
      "role": "CB",
      "category": "defending",
      "phase": "defending",
      "title": "Runner attacking the space behind",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "oppRunnerNear",
            "op": "==",
            "v": 1
          },
          {
            "f": "firstDefender",
            "op": "==",
            "v": 0
          }
        ]
      },
      "cues": [
        "Where is the runner going?",
        "Who is pressing the carrier?",
        "Is the line holding?"
      ],
      "actions": [
        {
          "id": "track_runner",
          "label": "Track the runner",
          "intent": "track_runner",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.6,
              "why": "a runner is going past you"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "you were needed on the carrier"
            }
          ]
        },
        {
          "id": "drop",
          "label": "Drop off",
          "intent": "drop",
          "base": 0.25,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners threaten the space behind"
            },
            {
              "when": [
                {
                  "f": "ballInOurBox",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "protect the goal first"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 35
                }
              ],
              "add": -0.2,
              "why": "too deep too early"
            }
          ]
        },
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        }
      ],
      "mistakes": [
        "Stepping to the ball and releasing the runner",
        "Dropping so deep the carrier walks forward"
      ],
      "difficultyFactors": [
        "Runner speed",
        "Distance to the carrier"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Runner tracked, ball played in behind, or attack slowed.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "oppRunnerNear": 1,
              "firstDefender": 0
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "oppRunnerNear": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CB_DEF_02",
      "role": "CB",
      "category": "defending",
      "phase": "defending",
      "title": "Carrier running at you",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "firstDefender",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 12
          }
        ]
      },
      "cues": [
        "Is there cover behind you?",
        "How fast are they moving?",
        "Which side do you want to send them?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "delay",
          "label": "Delay, stay goal-side",
          "intent": "delay",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "you are the nearest defender"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners behind you: slow them, do not dive in"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 4
                }
              ],
              "add": 0.2,
              "why": "close enough to slow them down"
            },
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "someone else is first: your job is cover"
            }
          ]
        },
        {
          "id": "communicate",
          "label": "Communicate and hand off",
          "intent": "communicate",
          "base": 0.2,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "a teammate has the carrier, organise around them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.3,
              "why": "you were the closest: act, then talk"
            }
          ]
        }
      ],
      "mistakes": [
        "Diving in without cover",
        "Backing off into the box"
      ],
      "difficultyFactors": [
        "Cover available",
        "Carrier speed and space"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Tackle, delay until cover, or the carrier goes past.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "firstDefender": 1,
              "carrierDist": 8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "firstDefender": 0,
              "carrierDist": 8
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CB_DEF_03",
      "role": "CB",
      "category": "defending",
      "phase": "defending",
      "title": "Cover the presser",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondDefender",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDistToOurGoal",
            "op": "<",
            "v": 40
          }
        ]
      },
      "cues": [
        "Who is pressing?",
        "Where would the carrier go if they beat them?",
        "Any runner behind you?"
      ],
      "actions": [
        {
          "id": "cover",
          "label": "Cover behind the presser",
          "intent": "cover",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "you are second: cover the presser"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a teammate is pressing"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "you were nearest: someone must press"
            }
          ]
        },
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "track_runner",
          "label": "Track the runner",
          "intent": "track_runner",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.6,
              "why": "a runner is going past you"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "you were needed on the carrier"
            }
          ]
        }
      ],
      "mistakes": [
        "Both defenders pressing the same player",
        "Standing level with the presser"
      ],
      "difficultyFactors": [
        "Runner presence",
        "Presser distance"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Presser beaten into cover, or ball won.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "secondDefender": 1,
              "carrierDistToOurGoal": 30
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "secondDefender": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CB_OFF_01",
      "role": "CB",
      "category": "off_ball",
      "phase": "build_up",
      "title": "Support the build-up",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballProgress",
            "op": "<",
            "v": 0.5
          },
          {
            "f": "teammateCarrierDist",
            "op": "<",
            "v": 25
          }
        ]
      },
      "cues": [
        "Can the carrier see you?",
        "Is a forward pass on for them?",
        "Where is their striker?"
      ],
      "actions": [
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "hold_position",
          "label": "Hold position",
          "intent": "hold_position",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.1,
              "why": "shape first when they have the ball"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "your teammate needed help"
            }
          ]
        },
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        }
      ],
      "mistakes": [
        "Hiding behind their striker",
        "Pushing up and leaving the keeper without an outlet"
      ],
      "difficultyFactors": [
        "Carrier pressure",
        "Striker position"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Outlet used or team progresses without you.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballProgress": 0.3,
              "teammateCarrierDist": 15
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballProgress": 0.7,
              "teammateCarrierDist": 15
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CB_TRANS_01",
      "role": "CB",
      "category": "transition",
      "phase": "transition",
      "title": "Just won it back",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 3
          }
        ]
      },
      "cues": [
        "Are they disorganised?",
        "Who is free immediately?",
        "Is the safe pass better than the quick one?"
      ],
      "actions": [
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        }
      ],
      "mistakes": [
        "Kicking it away straight back to them",
        "Slowing down when they are open"
      ],
      "difficultyFactors": [
        "Opponent recovery speed",
        "Immediate options"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter started or possession settled.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 20
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RB_RECV_01",
      "role": "RB",
      "category": "on_ball",
      "phase": "build_up",
      "title": "Receiving wide",
      "trigger": {
        "all": [
          {
            "f": "receiving",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Is the winger ahead free?",
        "Where is the presser?",
        "Can you turn forward?"
      ],
      "actions": [
        {
          "id": "touch_forward",
          "label": "First touch forward",
          "intent": "first_touch_forward",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "space to turn into"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.5,
              "why": "a defender arrives as the ball does"
            }
          ]
        },
        {
          "id": "touch_safe",
          "label": "Safe touch away from pressure",
          "intent": "first_touch_safe",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "pressure is arriving: protect the ball first"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space ahead went unused"
            }
          ]
        }
      ],
      "mistakes": [
        "Turning blind into the presser",
        "Safe touch when the touchline is wide open"
      ],
      "difficultyFactors": [
        "Pressure at receipt",
        "Space ahead"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Full back turns forward or protects the ball.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "receiving": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "receiving": 0,
              "hasBall": 1
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RB_ON_01",
      "role": "RB",
      "category": "on_ball",
      "phase": "progression",
      "title": "On the ball on the flank",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": ">=",
            "v": 0.3
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          }
        ]
      },
      "cues": [
        "Is the winger ahead or inside?",
        "Is the far side open?",
        "Where is the nearest defender?"
      ],
      "actions": [
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "draw_defender",
          "label": "Draw the defender",
          "intent": "draw_defender",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "a teammate is running beyond: commit the defender, then release"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "already under pressure, little time to draw anyone"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": -0.3,
              "why": "no defender close enough to draw"
            }
          ]
        }
      ],
      "mistakes": [
        "Always the same pass down the line",
        "Ignoring an open switch"
      ],
      "difficultyFactors": [
        "Open lanes",
        "Far-side space",
        "Pressure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Attack progresses wide, switches, or resets.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.5
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.2
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RB_OFF_01",
      "role": "RB",
      "category": "off_ball",
      "phase": "progression",
      "title": "Winger has the ball on your side",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 1
          },
          {
            "f": "ballProgress",
            "op": ">",
            "v": 0.5
          },
          {
            "f": "teammateCarrierDist",
            "op": "<",
            "v": 20
          }
        ]
      },
      "cues": [
        "Is the outside lane free?",
        "Is the winger pressed?",
        "Who covers if you go?"
      ],
      "actions": [
        {
          "id": "overlap",
          "label": "Overlap outside",
          "intent": "overlap",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "ballOnMyFlank",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the ball is on your side"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.3,
              "why": "the wide lane is free"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.1,
              "why": "the carrier is pressed, the overlap may be late"
            }
          ]
        },
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "hold_position",
          "label": "Hold position",
          "intent": "hold_position",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.1,
              "why": "shape first when they have the ball"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "your teammate needed help"
            }
          ]
        }
      ],
      "mistakes": [
        "Overlapping into a covered lane",
        "Staying back while the winger is isolated"
      ],
      "difficultyFactors": [
        "Wide lane space",
        "Carrier pressure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Overlap used, support used, or shape kept.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 1,
              "ballProgress": 0.6,
              "teammateCarrierDist": 10
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 0,
              "ballProgress": 0.6,
              "teammateCarrierDist": 10
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RB_DEF_01",
      "role": "RB",
      "category": "defending",
      "phase": "defending",
      "title": "Winger running at you",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "firstDefender",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 10
          }
        ]
      },
      "cues": [
        "Is there cover inside?",
        "Are they faster than you?",
        "Which way do you show them?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "delay",
          "label": "Delay, stay goal-side",
          "intent": "delay",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "you are the nearest defender"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners behind you: slow them, do not dive in"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 4
                }
              ],
              "add": 0.2,
              "why": "close enough to slow them down"
            },
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "someone else is first: your job is cover"
            }
          ]
        },
        {
          "id": "cover",
          "label": "Cover behind the presser",
          "intent": "cover",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "you are second: cover the presser"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a teammate is pressing"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "you were nearest: someone must press"
            }
          ]
        }
      ],
      "mistakes": [
        "Diving in and getting beaten outside",
        "Backing off to the byline"
      ],
      "difficultyFactors": [
        "Cover",
        "Carrier speed"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Tackle, delay, or cross conceded.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "firstDefender": 1,
              "carrierDist": 6
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "firstDefender": 0,
              "carrierDist": 6
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RB_DEF_02",
      "role": "RB",
      "category": "defending",
      "phase": "defending",
      "title": "Ball on the far side, runner near you",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 0
          },
          {
            "f": "oppRunnerNear",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Where is the far-side winger?",
        "Can a cross reach them?",
        "Is your line level?"
      ],
      "actions": [
        {
          "id": "track_runner",
          "label": "Track the runner",
          "intent": "track_runner",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.6,
              "why": "a runner is going past you"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "you were needed on the carrier"
            }
          ]
        },
        {
          "id": "drop",
          "label": "Drop off",
          "intent": "drop",
          "base": 0.25,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners threaten the space behind"
            },
            {
              "when": [
                {
                  "f": "ballInOurBox",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "protect the goal first"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 35
                }
              ],
              "add": -0.2,
              "why": "too deep too early"
            }
          ]
        },
        {
          "id": "hold_position",
          "label": "Hold position",
          "intent": "hold_position",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.1,
              "why": "shape first when they have the ball"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "your teammate needed help"
            }
          ]
        }
      ],
      "mistakes": [
        "Watching the ball and losing the runner",
        "Tucking in too far and leaving the winger free"
      ],
      "difficultyFactors": [
        "Runner timing",
        "Distance to the ball"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Runner tracked or switch finds them.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "ballOnMyFlank": 0,
              "oppRunnerNear": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "ballOnMyFlank": 1,
              "oppRunnerNear": 1
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RB_TRANS_01",
      "role": "RB",
      "category": "transition",
      "phase": "transition",
      "title": "Ball lost on your flank",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 3
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 15
          }
        ]
      },
      "cues": [
        "Can you press before they settle?",
        "Who is behind you?",
        "Is a runner already going?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "delay",
          "label": "Delay, stay goal-side",
          "intent": "delay",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "you are the nearest defender"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners behind you: slow them, do not dive in"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 4
                }
              ],
              "add": 0.2,
              "why": "close enough to slow them down"
            },
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "someone else is first: your job is cover"
            }
          ]
        },
        {
          "id": "drop",
          "label": "Drop off",
          "intent": "drop",
          "base": 0.25,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners threaten the space behind"
            },
            {
              "when": [
                {
                  "f": "ballInOurBox",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "protect the goal first"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 35
                }
              ],
              "add": -0.2,
              "why": "too deep too early"
            }
          ]
        }
      ],
      "mistakes": [
        "Sprinting at the carrier with nobody behind",
        "Retreating and giving a free run"
      ],
      "difficultyFactors": [
        "Cover",
        "Carrier composure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter-press wins it or recovery run.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "secondsSinceTurnover": 1,
              "ballOnMyFlank": 1,
              "carrierDist": 8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "secondsSinceTurnover": 30,
              "ballOnMyFlank": 1,
              "carrierDist": 8
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "LB_RECV_01",
      "role": "LB",
      "category": "on_ball",
      "phase": "build_up",
      "title": "Receiving wide",
      "trigger": {
        "all": [
          {
            "f": "receiving",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Is the winger ahead free?",
        "Where is the presser?",
        "Can you turn forward?"
      ],
      "actions": [
        {
          "id": "touch_forward",
          "label": "First touch forward",
          "intent": "first_touch_forward",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "space to turn into"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.5,
              "why": "a defender arrives as the ball does"
            }
          ]
        },
        {
          "id": "touch_safe",
          "label": "Safe touch away from pressure",
          "intent": "first_touch_safe",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "pressure is arriving: protect the ball first"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space ahead went unused"
            }
          ]
        }
      ],
      "mistakes": [
        "Turning blind into the presser",
        "Safe touch when the touchline is wide open"
      ],
      "difficultyFactors": [
        "Pressure at receipt",
        "Space ahead"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Full back turns forward or protects the ball.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "receiving": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "receiving": 0,
              "hasBall": 1
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RB_RECV_01"
    },
    {
      "id": "LB_ON_01",
      "role": "LB",
      "category": "on_ball",
      "phase": "progression",
      "title": "On the ball on the flank",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": ">=",
            "v": 0.3
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          }
        ]
      },
      "cues": [
        "Is the winger ahead or inside?",
        "Is the far side open?",
        "Where is the nearest defender?"
      ],
      "actions": [
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "draw_defender",
          "label": "Draw the defender",
          "intent": "draw_defender",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "a teammate is running beyond: commit the defender, then release"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "already under pressure, little time to draw anyone"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": -0.3,
              "why": "no defender close enough to draw"
            }
          ]
        }
      ],
      "mistakes": [
        "Always the same pass down the line",
        "Ignoring an open switch"
      ],
      "difficultyFactors": [
        "Open lanes",
        "Far-side space",
        "Pressure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Attack progresses wide, switches, or resets.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.5
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.2
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RB_ON_01"
    },
    {
      "id": "LB_OFF_01",
      "role": "LB",
      "category": "off_ball",
      "phase": "progression",
      "title": "Winger has the ball on your side",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 1
          },
          {
            "f": "ballProgress",
            "op": ">",
            "v": 0.5
          },
          {
            "f": "teammateCarrierDist",
            "op": "<",
            "v": 20
          }
        ]
      },
      "cues": [
        "Is the outside lane free?",
        "Is the winger pressed?",
        "Who covers if you go?"
      ],
      "actions": [
        {
          "id": "overlap",
          "label": "Overlap outside",
          "intent": "overlap",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "ballOnMyFlank",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the ball is on your side"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.3,
              "why": "the wide lane is free"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.1,
              "why": "the carrier is pressed, the overlap may be late"
            }
          ]
        },
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "hold_position",
          "label": "Hold position",
          "intent": "hold_position",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.1,
              "why": "shape first when they have the ball"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "your teammate needed help"
            }
          ]
        }
      ],
      "mistakes": [
        "Overlapping into a covered lane",
        "Staying back while the winger is isolated"
      ],
      "difficultyFactors": [
        "Wide lane space",
        "Carrier pressure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Overlap used, support used, or shape kept.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 1,
              "ballProgress": 0.6,
              "teammateCarrierDist": 10
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 0,
              "ballProgress": 0.6,
              "teammateCarrierDist": 10
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RB_OFF_01"
    },
    {
      "id": "LB_DEF_01",
      "role": "LB",
      "category": "defending",
      "phase": "defending",
      "title": "Winger running at you",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "firstDefender",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 10
          }
        ]
      },
      "cues": [
        "Is there cover inside?",
        "Are they faster than you?",
        "Which way do you show them?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "delay",
          "label": "Delay, stay goal-side",
          "intent": "delay",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "you are the nearest defender"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners behind you: slow them, do not dive in"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 4
                }
              ],
              "add": 0.2,
              "why": "close enough to slow them down"
            },
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "someone else is first: your job is cover"
            }
          ]
        },
        {
          "id": "cover",
          "label": "Cover behind the presser",
          "intent": "cover",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "you are second: cover the presser"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a teammate is pressing"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "you were nearest: someone must press"
            }
          ]
        }
      ],
      "mistakes": [
        "Diving in and getting beaten outside",
        "Backing off to the byline"
      ],
      "difficultyFactors": [
        "Cover",
        "Carrier speed"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Tackle, delay, or cross conceded.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "firstDefender": 1,
              "carrierDist": 6
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "firstDefender": 0,
              "carrierDist": 6
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RB_DEF_01"
    },
    {
      "id": "LB_DEF_02",
      "role": "LB",
      "category": "defending",
      "phase": "defending",
      "title": "Ball on the far side, runner near you",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 0
          },
          {
            "f": "oppRunnerNear",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Where is the far-side winger?",
        "Can a cross reach them?",
        "Is your line level?"
      ],
      "actions": [
        {
          "id": "track_runner",
          "label": "Track the runner",
          "intent": "track_runner",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.6,
              "why": "a runner is going past you"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "you were needed on the carrier"
            }
          ]
        },
        {
          "id": "drop",
          "label": "Drop off",
          "intent": "drop",
          "base": 0.25,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners threaten the space behind"
            },
            {
              "when": [
                {
                  "f": "ballInOurBox",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "protect the goal first"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 35
                }
              ],
              "add": -0.2,
              "why": "too deep too early"
            }
          ]
        },
        {
          "id": "hold_position",
          "label": "Hold position",
          "intent": "hold_position",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.1,
              "why": "shape first when they have the ball"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "your teammate needed help"
            }
          ]
        }
      ],
      "mistakes": [
        "Watching the ball and losing the runner",
        "Tucking in too far and leaving the winger free"
      ],
      "difficultyFactors": [
        "Runner timing",
        "Distance to the ball"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Runner tracked or switch finds them.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "ballOnMyFlank": 0,
              "oppRunnerNear": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "ballOnMyFlank": 1,
              "oppRunnerNear": 1
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RB_DEF_02"
    },
    {
      "id": "LB_TRANS_01",
      "role": "LB",
      "category": "transition",
      "phase": "transition",
      "title": "Ball lost on your flank",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 3
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 15
          }
        ]
      },
      "cues": [
        "Can you press before they settle?",
        "Who is behind you?",
        "Is a runner already going?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "delay",
          "label": "Delay, stay goal-side",
          "intent": "delay",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "you are the nearest defender"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners behind you: slow them, do not dive in"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 4
                }
              ],
              "add": 0.2,
              "why": "close enough to slow them down"
            },
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "someone else is first: your job is cover"
            }
          ]
        },
        {
          "id": "drop",
          "label": "Drop off",
          "intent": "drop",
          "base": 0.25,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners threaten the space behind"
            },
            {
              "when": [
                {
                  "f": "ballInOurBox",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "protect the goal first"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 35
                }
              ],
              "add": -0.2,
              "why": "too deep too early"
            }
          ]
        }
      ],
      "mistakes": [
        "Sprinting at the carrier with nobody behind",
        "Retreating and giving a free run"
      ],
      "difficultyFactors": [
        "Cover",
        "Carrier composure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter-press wins it or recovery run.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "secondsSinceTurnover": 1,
              "ballOnMyFlank": 1,
              "carrierDist": 8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "secondsSinceTurnover": 30,
              "ballOnMyFlank": 1,
              "carrierDist": 8
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RB_TRANS_01"
    },
    {
      "id": "DM_ON_01",
      "role": "DM",
      "category": "on_ball",
      "phase": "progression",
      "title": "On the ball in midfield with time",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": ">=",
            "v": 0.3
          },
          {
            "f": "progress",
            "op": "<=",
            "v": 0.7
          },
          {
            "f": "pressure",
            "op": "<",
            "v": 0.5
          }
        ]
      },
      "cues": [
        "Which forward is between the lines?",
        "Is the far side open?",
        "Can you carry into the gap?"
      ],
      "actions": [
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        }
      ],
      "mistakes": [
        "Slow sideways passes when a forward is free",
        "Carrying into traffic"
      ],
      "difficultyFactors": [
        "Open lanes",
        "Far-side space"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Team progresses or switches.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.5,
              "pressure": 0.1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.5,
              "pressure": 0.9
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "DM_ON_02",
      "role": "DM",
      "category": "on_ball",
      "phase": "progression",
      "title": "Pressed in midfield",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "pressure",
            "op": ">=",
            "v": 0.5
          }
        ]
      },
      "cues": [
        "Which side is free?",
        "Who is the safe outlet?",
        "Is there a gap behind the presser?"
      ],
      "actions": [
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        }
      ],
      "mistakes": [
        "Turning into the presser",
        "Holding too long"
      ],
      "difficultyFactors": [
        "Pressure",
        "Time"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Pressure escaped or ball lost centrally.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "pressure": 0.8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "pressure": 0.2
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "DM_RECV_01",
      "role": "DM",
      "category": "on_ball",
      "phase": "build_up",
      "title": "Receiving with your back to play",
      "trigger": {
        "all": [
          {
            "f": "receiving",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Did you scan before the ball arrived?",
        "Is the presser behind you?",
        "Which way is open?"
      ],
      "actions": [
        {
          "id": "touch_forward",
          "label": "First touch forward",
          "intent": "first_touch_forward",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "space to turn into"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.5,
              "why": "a defender arrives as the ball does"
            }
          ]
        },
        {
          "id": "touch_safe",
          "label": "Safe touch away from pressure",
          "intent": "first_touch_safe",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "pressure is arriving: protect the ball first"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space ahead went unused"
            }
          ]
        }
      ],
      "mistakes": [
        "Turning blind",
        "Always playing it back"
      ],
      "difficultyFactors": [
        "Pressure from behind",
        "Space ahead"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Turn forward or protect and recycle.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "receiving": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "receiving": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "DM_OFF_01",
      "role": "DM",
      "category": "off_ball",
      "phase": "progression",
      "title": "Carrier is pressed, offer support",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "carrierPressure",
            "op": ">",
            "v": 0.5
          },
          {
            "f": "teammateCarrierDist",
            "op": "<",
            "v": 20
          }
        ]
      },
      "cues": [
        "Which angle can the carrier see?",
        "Is the forward option better?",
        "Who covers if you go?"
      ],
      "actions": [
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "hold_position",
          "label": "Hold position",
          "intent": "hold_position",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.1,
              "why": "shape first when they have the ball"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "your teammate needed help"
            }
          ]
        },
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        }
      ],
      "mistakes": [
        "Standing behind a defender",
        "Running away from a pressed carrier"
      ],
      "difficultyFactors": [
        "Carrier pressure",
        "Angle available"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Outlet used or carrier finds another option.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "carrierPressure": 0.7,
              "teammateCarrierDist": 10
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "carrierPressure": 0.1,
              "teammateCarrierDist": 10
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "DM_DEF_01",
      "role": "DM",
      "category": "defending",
      "phase": "defending",
      "title": "Screen in front of the defence",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": ">=",
            "v": 5
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 20
          },
          {
            "f": "teammatePressing",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Which pass hurts most?",
        "Who is pressing?",
        "Is a runner going past you?"
      ],
      "actions": [
        {
          "id": "screen_lane",
          "label": "Screen the passing lane",
          "intent": "screen_lane",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "the carrier is pressed: cut the outlet"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 5
                }
              ],
              "add": -0.2,
              "why": "you were close enough to press yourself"
            }
          ]
        },
        {
          "id": "cover",
          "label": "Cover behind the presser",
          "intent": "cover",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "you are second: cover the presser"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a teammate is pressing"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "you were nearest: someone must press"
            }
          ]
        },
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        }
      ],
      "mistakes": [
        "Chasing the ball and opening the middle",
        "Screening a harmless lane"
      ],
      "difficultyFactors": [
        "Number of dangerous receivers",
        "Presser distance"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Lane cut, cover provided, or ball played through.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDist": 10,
              "teammatePressing": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDist": 10,
              "teammatePressing": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "DM_TRANS_01",
      "role": "DM",
      "category": "transition",
      "phase": "transition",
      "title": "Turnover in midfield",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 3
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 15
          }
        ]
      },
      "cues": [
        "Can you win it back immediately?",
        "Who is behind you?",
        "Is the carrier facing you?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "delay",
          "label": "Delay, stay goal-side",
          "intent": "delay",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "you are the nearest defender"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners behind you: slow them, do not dive in"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 4
                }
              ],
              "add": 0.2,
              "why": "close enough to slow them down"
            },
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "someone else is first: your job is cover"
            }
          ]
        },
        {
          "id": "drop",
          "label": "Drop off",
          "intent": "drop",
          "base": 0.25,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners threaten the space behind"
            },
            {
              "when": [
                {
                  "f": "ballInOurBox",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "protect the goal first"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 35
                }
              ],
              "add": -0.2,
              "why": "too deep too early"
            }
          ]
        }
      ],
      "mistakes": [
        "Everyone chasing",
        "Nobody pressing"
      ],
      "difficultyFactors": [
        "Cover",
        "Carrier orientation"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter-press or recovery shape.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "secondsSinceTurnover": 1,
              "carrierDist": 8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "secondsSinceTurnover": 30,
              "carrierDist": 8
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CM_ON_01",
      "role": "CM",
      "category": "on_ball",
      "phase": "progression",
      "title": "On the ball between the lines",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": ">",
            "v": 0.45
          },
          {
            "f": "pressure",
            "op": "<",
            "v": 0.6
          }
        ]
      },
      "cues": [
        "Is the striker moving?",
        "Is a winger free far side?",
        "Is a defender stepping to you?"
      ],
      "actions": [
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "draw_defender",
          "label": "Draw the defender",
          "intent": "draw_defender",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "a teammate is running beyond: commit the defender, then release"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "already under pressure, little time to draw anyone"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": -0.3,
              "why": "no defender close enough to draw"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        }
      ],
      "mistakes": [
        "Rushing the pass before the run develops",
        "Not shooting when the lane opens"
      ],
      "difficultyFactors": [
        "Runner timing",
        "Shot window",
        "Lanes"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Chance created, switch, or possession kept.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.6,
              "pressure": 0.2
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.6,
              "pressure": 0.9
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CM_ON_02",
      "role": "CM",
      "category": "on_ball",
      "phase": "progression",
      "title": "Pressed in possession",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "pressure",
            "op": ">=",
            "v": 0.6
          }
        ]
      },
      "cues": [
        "Where is the free teammate?",
        "Is there a gap behind the presser?",
        "Is the spare player on the far side?"
      ],
      "actions": [
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        }
      ],
      "mistakes": [
        "Turning into pressure",
        "Forcing a pass through bodies"
      ],
      "difficultyFactors": [
        "Pressure",
        "Time"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Pressure escaped or turnover.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "pressure": 0.8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "pressure": 0.2
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CM_RECV_01",
      "role": "CM",
      "category": "on_ball",
      "phase": "progression",
      "title": "Receiving in midfield",
      "trigger": {
        "all": [
          {
            "f": "receiving",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Scan: who is behind you?",
        "Which side is open?"
      ],
      "actions": [
        {
          "id": "touch_forward",
          "label": "First touch forward",
          "intent": "first_touch_forward",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "space to turn into"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.5,
              "why": "a defender arrives as the ball does"
            }
          ]
        },
        {
          "id": "touch_safe",
          "label": "Safe touch away from pressure",
          "intent": "first_touch_safe",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "pressure is arriving: protect the ball first"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space ahead went unused"
            }
          ]
        }
      ],
      "mistakes": [
        "Stopping the ball dead under pressure",
        "Touching into the presser"
      ],
      "difficultyFactors": [
        "Pressure",
        "Pass speed"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Turn forward or protect.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "receiving": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "receiving": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CM_OFF_01",
      "role": "CM",
      "category": "off_ball",
      "phase": "progression",
      "title": "Third-player support",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "teammateCarrierDist",
            "op": "<",
            "v": 18
          }
        ]
      },
      "cues": [
        "Is the carrier pressed?",
        "Is there room behind their line?",
        "Which angle is open?"
      ],
      "actions": [
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        },
        {
          "id": "hold_position",
          "label": "Hold position",
          "intent": "hold_position",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.1,
              "why": "shape first when they have the ball"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "your teammate needed help"
            }
          ]
        }
      ],
      "mistakes": [
        "Standing in a defender's shadow",
        "Running offside"
      ],
      "difficultyFactors": [
        "Carrier pressure",
        "Space behind"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Combination, run behind, or shape.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "teammateCarrierDist": 10
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "teammateCarrierDist": 30
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CM_DEF_01",
      "role": "CM",
      "category": "defending",
      "phase": "defending",
      "title": "Press or hold",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 12
          },
          {
            "f": "firstDefender",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Is the carrier facing you?",
        "Who covers behind?",
        "Which lane would they use?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "delay",
          "label": "Delay, stay goal-side",
          "intent": "delay",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "you are the nearest defender"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners behind you: slow them, do not dive in"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 4
                }
              ],
              "add": 0.2,
              "why": "close enough to slow them down"
            },
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "someone else is first: your job is cover"
            }
          ]
        },
        {
          "id": "screen_lane",
          "label": "Screen the passing lane",
          "intent": "screen_lane",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "the carrier is pressed: cut the outlet"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 5
                }
              ],
              "add": -0.2,
              "why": "you were close enough to press yourself"
            }
          ]
        }
      ],
      "mistakes": [
        "Pressing with the lane behind wide open",
        "Standing off a carrier who has time"
      ],
      "difficultyFactors": [
        "Cover",
        "Carrier orientation"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Ball won, carrier delayed, or lane played.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDist": 8,
              "firstDefender": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDist": 8,
              "firstDefender": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "CM_TRANS_01",
      "role": "CM",
      "category": "transition",
      "phase": "transition",
      "title": "Won it in midfield",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 3
          }
        ]
      },
      "cues": [
        "Are they disorganised?",
        "Is the striker ready to run?",
        "Is a shot on?",
        "Is the far side open?"
      ],
      "actions": [
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        }
      ],
      "mistakes": [
        "Slowing the counter",
        "Blasting a hopeful shot"
      ],
      "difficultyFactors": [
        "Opponent recovery",
        "Runner timing"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter or possession.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 20
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RW_ON_01",
      "role": "RW",
      "category": "on_ball",
      "phase": "final_third",
      "title": "1v1 wide",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": ">",
            "v": 0.5
          },
          {
            "f": "nearestOppDist",
            "op": "<",
            "v": 6
          }
        ]
      },
      "cues": [
        "Which foot is the defender on?",
        "Is the full back overlapping?",
        "Is the cutback on?",
        "Is the far winger free?"
      ],
      "actions": [
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "draw_defender",
          "label": "Draw the defender",
          "intent": "draw_defender",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "a teammate is running beyond: commit the defender, then release"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "already under pressure, little time to draw anyone"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": -0.3,
              "why": "no defender close enough to draw"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        }
      ],
      "mistakes": [
        "Dribbling into two defenders",
        "Passing away a winnable 1v1"
      ],
      "difficultyFactors": [
        "Defender distance",
        "Support arriving"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Beat the defender, combine, or reset.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.7,
              "nearestOppDist": 3
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.7,
              "nearestOppDist": 10
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RW_ON_02",
      "role": "RW",
      "category": "on_ball",
      "phase": "final_third",
      "title": "Ball wide with time",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": ">",
            "v": 0.5
          },
          {
            "f": "nearestOppDist",
            "op": ">=",
            "v": 6
          }
        ]
      },
      "cues": [
        "Is the striker making a run?",
        "Is the far winger free?",
        "Can you drive at the box?"
      ],
      "actions": [
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        }
      ],
      "mistakes": [
        "Waiting until the defender arrives",
        "Crossing to nobody"
      ],
      "difficultyFactors": [
        "Runner timing",
        "Far-side space"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Chance, switch, or possession.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.7,
              "nearestOppDist": 9
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.3,
              "nearestOppDist": 9
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RW_BUILD_01",
      "role": "RW",
      "category": "on_ball",
      "phase": "progression",
      "title": "Ball wide in your own half",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": "<=",
            "v": 0.5
          },
          {
            "f": "secondsSinceTurnover",
            "op": ">=",
            "v": 3
          }
        ]
      },
      "cues": [
        "Is the full back behind you free?",
        "Is the pass inside on, or is the lane closed?",
        "Is the far side open?",
        "Is the defender jumping to press?"
      ],
      "actions": [
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "draw_defender",
          "label": "Draw the defender",
          "intent": "draw_defender",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "a teammate is running beyond: commit the defender, then release"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "already under pressure, little time to draw anyone"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": -0.3,
              "why": "no defender close enough to draw"
            }
          ]
        }
      ],
      "mistakes": [
        "Turning into the touchline with a defender closing",
        "Forcing it inside through bodies when the reset is free"
      ],
      "difficultyFactors": [
        "Pressure",
        "Inside lane",
        "Far-side space"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Progressed, switched, or possession kept.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.35,
              "pressure": 0.5
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.8,
              "pressure": 0.5
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RW_TRANS_01",
      "role": "RW",
      "category": "transition",
      "phase": "transition",
      "title": "Won it wide",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 3
          }
        ]
      },
      "cues": [
        "Is their full back out of position?",
        "Is the striker ready to run?",
        "Is the far side open?"
      ],
      "actions": [
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        }
      ],
      "mistakes": [
        "Slowing the counter with an extra touch",
        "Running into the recovering defender"
      ],
      "difficultyFactors": [
        "Opponent recovery",
        "Runner timing"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter or possession.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 20
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RW_OFF_01",
      "role": "RW",
      "category": "off_ball",
      "phase": "progression",
      "title": "Ball on the far side",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 0
          }
        ]
      },
      "cues": [
        "Is the far-side defender watching the ball?",
        "Is a switch possible?",
        "Is there room behind?",
        "Is the full back already giving width, and is the far post open?"
      ],
      "actions": [
        {
          "id": "hold_width",
          "label": "Hold width",
          "intent": "hold_width",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.2,
              "why": "staying wide keeps the lane open"
            },
            {
              "when": [
                {
                  "f": "ballOnMyFlank",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.2,
              "why": "stay available as the switch target"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.2,
              "why": "there was room behind: a run was on"
            },
            {
              "when": [
                {
                  "f": "secondNineOn",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "the full back already held width: the far-post run was on"
            }
          ]
        },
        {
          "id": "narrow_inside",
          "label": "Narrow inside as the second striker",
          "intent": "narrow_inside",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "secondNineOn",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "ball secured on the far side, width covered, far-post space open"
            },
            {
              "when": [
                {
                  "f": "widthProvidedMyFlank",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.5,
              "why": "nobody else holds width on your side: narrowing kills the switch"
            },
            {
              "when": [
                {
                  "f": "restDefenseCount",
                  "op": "<",
                  "v": 3
                }
              ],
              "add": -0.3,
              "why": "too few behind the ball to protect the counter"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": -0.3,
              "why": "the carrier is pressed: the ball is not secured on the far side"
            },
            {
              "when": [
                {
                  "f": "farPostSpace",
                  "op": "<",
                  "v": 0.45
                }
              ],
              "add": -0.3,
              "why": "the far-post space is crowded"
            }
          ]
        },
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        },
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        }
      ],
      "mistakes": [
        "Drifting inside and closing the switch",
        "Running offside early",
        "Narrowing when nobody else holds width"
      ],
      "difficultyFactors": [
        "Switch availability",
        "Space behind",
        "Width cover from the full back"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Switch found, far-post run, run behind, or shape.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 0
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 1
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RW_OFF_02",
      "role": "RW",
      "category": "off_ball",
      "phase": "progression",
      "title": "Ball on your side, room behind",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 1
          },
          {
            "f": "spaceBehindLine",
            "op": ">",
            "v": 8
          },
          {
            "f": "teammateCarrierDist",
            "op": "<",
            "v": 25
          }
        ]
      },
      "cues": [
        "Are you onside?",
        "Can the carrier see you?",
        "Where is the space?"
      ],
      "actions": [
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        },
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "hold_width",
          "label": "Hold width",
          "intent": "hold_width",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.2,
              "why": "staying wide keeps the lane open"
            },
            {
              "when": [
                {
                  "f": "ballOnMyFlank",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.2,
              "why": "stay available as the switch target"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.2,
              "why": "there was room behind: a run was on"
            },
            {
              "when": [
                {
                  "f": "secondNineOn",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "the full back already held width: the far-post run was on"
            }
          ]
        }
      ],
      "mistakes": [
        "Going too early",
        "Coming short when the run is on"
      ],
      "difficultyFactors": [
        "Offside line",
        "Carrier pressure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Ball in behind or support angle.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 1,
              "spaceBehindLine": 15,
              "teammateCarrierDist": 12
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 1,
              "spaceBehindLine": 4,
              "teammateCarrierDist": 12
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RW_DEF_01",
      "role": "RW",
      "category": "defending",
      "phase": "defending",
      "title": "Their full back has the ball",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 12
          }
        ]
      },
      "cues": [
        "Can you press and cut inside?",
        "Who is behind you?",
        "Is the pass inside more dangerous?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "screen_lane",
          "label": "Screen the passing lane",
          "intent": "screen_lane",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "the carrier is pressed: cut the outlet"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 5
                }
              ],
              "add": -0.2,
              "why": "you were close enough to press yourself"
            }
          ]
        },
        {
          "id": "drop",
          "label": "Drop off",
          "intent": "drop",
          "base": 0.25,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners threaten the space behind"
            },
            {
              "when": [
                {
                  "f": "ballInOurBox",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "protect the goal first"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 35
                }
              ],
              "add": -0.2,
              "why": "too deep too early"
            }
          ]
        }
      ],
      "mistakes": [
        "Pressing from inside and opening the line",
        "Not tracking back"
      ],
      "difficultyFactors": [
        "Carrier distance",
        "Inside lane"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Press, screen, or recover.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDist": 8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDist": 30
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "RW_RECV_01",
      "role": "RW",
      "category": "on_ball",
      "phase": "progression",
      "title": "Receiving on the flank",
      "trigger": {
        "all": [
          {
            "f": "receiving",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Is the defender tight?",
        "Can you take it on the half-turn?"
      ],
      "actions": [
        {
          "id": "touch_forward",
          "label": "First touch forward",
          "intent": "first_touch_forward",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "space to turn into"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.5,
              "why": "a defender arrives as the ball does"
            }
          ]
        },
        {
          "id": "touch_safe",
          "label": "Safe touch away from pressure",
          "intent": "first_touch_safe",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "pressure is arriving: protect the ball first"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space ahead went unused"
            }
          ]
        }
      ],
      "mistakes": [
        "Letting the ball run to the defender",
        "Stopping it dead"
      ],
      "difficultyFactors": [
        "Pressure",
        "Pass quality"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Face forward or protect.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "receiving": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "receiving": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "LW_ON_01",
      "role": "LW",
      "category": "on_ball",
      "phase": "final_third",
      "title": "1v1 wide",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": ">",
            "v": 0.5
          },
          {
            "f": "nearestOppDist",
            "op": "<",
            "v": 6
          }
        ]
      },
      "cues": [
        "Which foot is the defender on?",
        "Is the full back overlapping?",
        "Is the cutback on?",
        "Is the far winger free?"
      ],
      "actions": [
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "draw_defender",
          "label": "Draw the defender",
          "intent": "draw_defender",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "a teammate is running beyond: commit the defender, then release"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "already under pressure, little time to draw anyone"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": -0.3,
              "why": "no defender close enough to draw"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        }
      ],
      "mistakes": [
        "Dribbling into two defenders",
        "Passing away a winnable 1v1"
      ],
      "difficultyFactors": [
        "Defender distance",
        "Support arriving"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Beat the defender, combine, or reset.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.7,
              "nearestOppDist": 3
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.7,
              "nearestOppDist": 10
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RW_ON_01"
    },
    {
      "id": "LW_ON_02",
      "role": "LW",
      "category": "on_ball",
      "phase": "final_third",
      "title": "Ball wide with time",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": ">",
            "v": 0.5
          },
          {
            "f": "nearestOppDist",
            "op": ">=",
            "v": 6
          }
        ]
      },
      "cues": [
        "Is the striker making a run?",
        "Is the far winger free?",
        "Can you drive at the box?"
      ],
      "actions": [
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        }
      ],
      "mistakes": [
        "Waiting until the defender arrives",
        "Crossing to nobody"
      ],
      "difficultyFactors": [
        "Runner timing",
        "Far-side space"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Chance, switch, or possession.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.7,
              "nearestOppDist": 9
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.3,
              "nearestOppDist": 9
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RW_ON_02"
    },
    {
      "id": "LW_BUILD_01",
      "role": "LW",
      "category": "on_ball",
      "phase": "progression",
      "title": "Ball wide in your own half",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "progress",
            "op": "<=",
            "v": 0.5
          },
          {
            "f": "secondsSinceTurnover",
            "op": ">=",
            "v": 3
          }
        ]
      },
      "cues": [
        "Is the full back behind you free?",
        "Is the pass inside on, or is the lane closed?",
        "Is the far side open?",
        "Is the defender jumping to press?"
      ],
      "actions": [
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "draw_defender",
          "label": "Draw the defender",
          "intent": "draw_defender",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "a teammate is running beyond: commit the defender, then release"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "already under pressure, little time to draw anyone"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": -0.3,
              "why": "no defender close enough to draw"
            }
          ]
        }
      ],
      "mistakes": [
        "Turning into the touchline with a defender closing",
        "Forcing it inside through bodies when the reset is free"
      ],
      "difficultyFactors": [
        "Pressure",
        "Inside lane",
        "Far-side space"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Progressed, switched, or possession kept.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "progress": 0.35,
              "pressure": 0.5
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "progress": 0.8,
              "pressure": 0.5
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RW_BUILD_01"
    },
    {
      "id": "LW_TRANS_01",
      "role": "LW",
      "category": "transition",
      "phase": "transition",
      "title": "Won it wide",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 3
          }
        ]
      },
      "cues": [
        "Is their full back out of position?",
        "Is the striker ready to run?",
        "Is the far side open?"
      ],
      "actions": [
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        },
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        }
      ],
      "mistakes": [
        "Slowing the counter with an extra touch",
        "Running into the recovering defender"
      ],
      "difficultyFactors": [
        "Opponent recovery",
        "Runner timing"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Counter or possession.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 20
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RW_TRANS_01"
    },
    {
      "id": "LW_OFF_01",
      "role": "LW",
      "category": "off_ball",
      "phase": "progression",
      "title": "Ball on the far side",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 0
          }
        ]
      },
      "cues": [
        "Is the far-side defender watching the ball?",
        "Is a switch possible?",
        "Is there room behind?",
        "Is the full back already giving width, and is the far post open?"
      ],
      "actions": [
        {
          "id": "hold_width",
          "label": "Hold width",
          "intent": "hold_width",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.2,
              "why": "staying wide keeps the lane open"
            },
            {
              "when": [
                {
                  "f": "ballOnMyFlank",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.2,
              "why": "stay available as the switch target"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.2,
              "why": "there was room behind: a run was on"
            },
            {
              "when": [
                {
                  "f": "secondNineOn",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "the full back already held width: the far-post run was on"
            }
          ]
        },
        {
          "id": "narrow_inside",
          "label": "Narrow inside as the second striker",
          "intent": "narrow_inside",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "secondNineOn",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "ball secured on the far side, width covered, far-post space open"
            },
            {
              "when": [
                {
                  "f": "widthProvidedMyFlank",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.5,
              "why": "nobody else holds width on your side: narrowing kills the switch"
            },
            {
              "when": [
                {
                  "f": "restDefenseCount",
                  "op": "<",
                  "v": 3
                }
              ],
              "add": -0.3,
              "why": "too few behind the ball to protect the counter"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": -0.3,
              "why": "the carrier is pressed: the ball is not secured on the far side"
            },
            {
              "when": [
                {
                  "f": "farPostSpace",
                  "op": "<",
                  "v": 0.45
                }
              ],
              "add": -0.3,
              "why": "the far-post space is crowded"
            }
          ]
        },
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        },
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        }
      ],
      "mistakes": [
        "Drifting inside and closing the switch",
        "Running offside early",
        "Narrowing when nobody else holds width"
      ],
      "difficultyFactors": [
        "Switch availability",
        "Space behind",
        "Width cover from the full back"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Switch found, far-post run, run behind, or shape.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 0
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 1
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RW_OFF_01"
    },
    {
      "id": "LW_OFF_02",
      "role": "LW",
      "category": "off_ball",
      "phase": "progression",
      "title": "Ball on your side, room behind",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "ballOnMyFlank",
            "op": "==",
            "v": 1
          },
          {
            "f": "spaceBehindLine",
            "op": ">",
            "v": 8
          },
          {
            "f": "teammateCarrierDist",
            "op": "<",
            "v": 25
          }
        ]
      },
      "cues": [
        "Are you onside?",
        "Can the carrier see you?",
        "Where is the space?"
      ],
      "actions": [
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        },
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "hold_width",
          "label": "Hold width",
          "intent": "hold_width",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.2,
              "why": "staying wide keeps the lane open"
            },
            {
              "when": [
                {
                  "f": "ballOnMyFlank",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.2,
              "why": "stay available as the switch target"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.2,
              "why": "there was room behind: a run was on"
            },
            {
              "when": [
                {
                  "f": "secondNineOn",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "the full back already held width: the far-post run was on"
            }
          ]
        }
      ],
      "mistakes": [
        "Going too early",
        "Coming short when the run is on"
      ],
      "difficultyFactors": [
        "Offside line",
        "Carrier pressure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Ball in behind or support angle.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 1,
              "spaceBehindLine": 15,
              "teammateCarrierDist": 12
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "ballOnMyFlank": 1,
              "spaceBehindLine": 4,
              "teammateCarrierDist": 12
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RW_OFF_02"
    },
    {
      "id": "LW_DEF_01",
      "role": "LW",
      "category": "defending",
      "phase": "defending",
      "title": "Their full back has the ball",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 12
          }
        ]
      },
      "cues": [
        "Can you press and cut inside?",
        "Who is behind you?",
        "Is the pass inside more dangerous?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "screen_lane",
          "label": "Screen the passing lane",
          "intent": "screen_lane",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "the carrier is pressed: cut the outlet"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 5
                }
              ],
              "add": -0.2,
              "why": "you were close enough to press yourself"
            }
          ]
        },
        {
          "id": "drop",
          "label": "Drop off",
          "intent": "drop",
          "base": 0.25,
          "eval": [
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners threaten the space behind"
            },
            {
              "when": [
                {
                  "f": "ballInOurBox",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "protect the goal first"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": ">",
                  "v": 35
                }
              ],
              "add": -0.2,
              "why": "too deep too early"
            }
          ]
        }
      ],
      "mistakes": [
        "Pressing from inside and opening the line",
        "Not tracking back"
      ],
      "difficultyFactors": [
        "Carrier distance",
        "Inside lane"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Press, screen, or recover.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDist": 8
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDist": 30
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RW_DEF_01"
    },
    {
      "id": "LW_RECV_01",
      "role": "LW",
      "category": "on_ball",
      "phase": "progression",
      "title": "Receiving on the flank",
      "trigger": {
        "all": [
          {
            "f": "receiving",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Is the defender tight?",
        "Can you take it on the half-turn?"
      ],
      "actions": [
        {
          "id": "touch_forward",
          "label": "First touch forward",
          "intent": "first_touch_forward",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "space to turn into"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.5,
              "why": "a defender arrives as the ball does"
            }
          ]
        },
        {
          "id": "touch_safe",
          "label": "Safe touch away from pressure",
          "intent": "first_touch_safe",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "pressure is arriving: protect the ball first"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space ahead went unused"
            }
          ]
        }
      ],
      "mistakes": [
        "Letting the ball run to the defender",
        "Stopping it dead"
      ],
      "difficultyFactors": [
        "Pressure",
        "Pass quality"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Face forward or protect.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "receiving": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "receiving": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      },
      "mirrorOf": "RW_RECV_01"
    },
    {
      "id": "ST_ON_01",
      "role": "ST",
      "category": "on_ball",
      "phase": "final_third",
      "title": "On the ball near goal",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "distToGoal",
            "op": "<",
            "v": 20
          }
        ]
      },
      "cues": [
        "Is the shot open?",
        "Is a teammate better placed?",
        "Is the defender committed?"
      ],
      "actions": [
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "draw_defender",
          "label": "Draw the defender",
          "intent": "draw_defender",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.5,
              "why": "a teammate is running beyond: commit the defender, then release"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "already under pressure, little time to draw anyone"
            },
            {
              "when": [
                {
                  "f": "nearestOppDist",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": -0.3,
              "why": "no defender close enough to draw"
            }
          ]
        },
        {
          "id": "lay_off",
          "label": "Lay it off to the arriving teammate",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "marked from behind: the first-time lay-off keeps it"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": -0.4,
              "why": "the shot was open"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "a forward option was on"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.3,
              "why": "nobody had arrived to receive it"
            }
          ]
        },
        {
          "id": "far_side",
          "label": "Find the far-side winger",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far-side winger is free"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": -0.5,
              "why": "the shot was open"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a cross-field pass under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is crowded: the spare player is on the far side"
            }
          ]
        }
      ],
      "mistakes": [
        "Shooting through a wall",
        "Passing when the shot is open"
      ],
      "difficultyFactors": [
        "Shot window",
        "Support"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Shot, combination, or reset.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "distToGoal": 12
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "distToGoal": 30
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "ST_ON_02",
      "role": "ST",
      "category": "on_ball",
      "phase": "progression",
      "title": "Back to goal",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "distToGoal",
            "op": ">=",
            "v": 20
          },
          {
            "f": "pressure",
            "op": ">",
            "v": 0.4
          }
        ]
      },
      "cues": [
        "Who is arriving underneath?",
        "Can you turn?",
        "Is a winger running?",
        "Is the far winger free?"
      ],
      "actions": [
        {
          "id": "recycle",
          "label": "Recycle possession",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "under pressure: keep the ball moving"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "nothing is on ahead"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.3,
              "why": "forward options were open, recycling wastes them"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.2,
              "why": "there was space to attack yourself"
            }
          ]
        },
        {
          "id": "hold_ball",
          "label": "Hold and shield",
          "intent": "hold_ball",
          "base": 0.15,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.8
                }
              ],
              "add": -0.3,
              "why": "shielding under heavy pressure invites the tackle"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.3,
              "why": "no passing option yet, buy time"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        }
      ],
      "mistakes": [
        "Turning into the defender",
        "Holding until dispossessed"
      ],
      "difficultyFactors": [
        "Pressure",
        "Support timing"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Lay-off, turn, or ball lost.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "distToGoal": 25,
              "pressure": 0.7
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "distToGoal": 25,
              "pressure": 0.1
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "ST_OFF_01",
      "role": "ST",
      "category": "off_ball",
      "phase": "progression",
      "title": "Room behind the defence",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "spaceBehindLine",
            "op": ">",
            "v": 8
          }
        ]
      },
      "cues": [
        "Are you onside?",
        "Can the carrier play it?",
        "Which side is the space?"
      ],
      "actions": [
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        },
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "hold_position",
          "label": "Hold position",
          "intent": "hold_position",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "theirPossession",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.1,
              "why": "shape first when they have the ball"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "your teammate needed help"
            }
          ]
        }
      ],
      "mistakes": [
        "Standing still on the line",
        "Running offside"
      ],
      "difficultyFactors": [
        "Offside line",
        "Carrier readiness"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Ball in behind or support.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "spaceBehindLine": 15
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "spaceBehindLine": 4
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "ST_OFF_02",
      "role": "ST",
      "category": "off_ball",
      "phase": "progression",
      "title": "Defence sitting deep",
      "trigger": {
        "all": [
          {
            "f": "ourPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "hasBall",
            "op": "==",
            "v": 0
          },
          {
            "f": "receiving",
            "op": "==",
            "v": 0
          },
          {
            "f": "spaceBehindLine",
            "op": "<=",
            "v": 8
          }
        ]
      },
      "cues": [
        "Can you drop and link?",
        "Is a winger free wide?",
        "Can you pull a defender out?"
      ],
      "actions": [
        {
          "id": "support_underneath",
          "label": "Support underneath",
          "intent": "support_underneath",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "the carrier needs a safe outlet"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": "<",
                  "v": 0.3
                }
              ],
              "add": -0.2,
              "why": "the carrier has time: a forward option is worth more"
            }
          ]
        },
        {
          "id": "run_behind",
          "label": "Run behind the defence",
          "intent": "run_behind",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 10
                }
              ],
              "add": 0.5,
              "why": "space behind the defence"
            },
            {
              "when": [
                {
                  "f": "onsideForRun",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.8,
              "why": "you were beyond the last defender: offside"
            },
            {
              "when": [
                {
                  "f": "carrierPressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "the carrier is pressed and cannot find you"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": -0.3,
              "why": "the defence is deep, no room behind"
            }
          ]
        },
        {
          "id": "hold_width",
          "label": "Hold width",
          "intent": "hold_width",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.2,
              "why": "staying wide keeps the lane open"
            },
            {
              "when": [
                {
                  "f": "ballOnMyFlank",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": 0.2,
              "why": "stay available as the switch target"
            },
            {
              "when": [
                {
                  "f": "spaceBehindLine",
                  "op": ">",
                  "v": 12
                }
              ],
              "add": -0.2,
              "why": "there was room behind: a run was on"
            },
            {
              "when": [
                {
                  "f": "secondNineOn",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "the full back already held width: the far-post run was on"
            }
          ]
        }
      ],
      "mistakes": [
        "Running into a packed line",
        "Hiding behind defenders"
      ],
      "difficultyFactors": [
        "Deep block",
        "Support"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Link play or hold shape.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "ourPossession": 1,
              "spaceBehindLine": 5
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "ourPossession": 1,
              "spaceBehindLine": 15
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "ST_RECV_01",
      "role": "ST",
      "category": "on_ball",
      "phase": "final_third",
      "title": "Receiving near goal",
      "trigger": {
        "all": [
          {
            "f": "receiving",
            "op": "==",
            "v": 1
          }
        ]
      },
      "cues": [
        "Where is the defender?",
        "Can you set the shot with one touch?"
      ],
      "actions": [
        {
          "id": "touch_forward",
          "label": "First touch forward",
          "intent": "first_touch_forward",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "space to turn into"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.5,
              "why": "a defender arrives as the ball does"
            }
          ]
        },
        {
          "id": "touch_safe",
          "label": "Safe touch away from pressure",
          "intent": "first_touch_safe",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.5,
              "why": "pressure is arriving: protect the ball first"
            },
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space ahead went unused"
            }
          ]
        }
      ],
      "mistakes": [
        "Taking a heavy touch toward the keeper",
        "Touching back into the defender"
      ],
      "difficultyFactors": [
        "Pressure",
        "Angle"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Shot set up or ball protected.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "receiving": 1
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "receiving": 0
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "ST_DEF_01",
      "role": "ST",
      "category": "defending",
      "phase": "defending",
      "title": "Their centre back has the ball",
      "trigger": {
        "all": [
          {
            "f": "theirPossession",
            "op": "==",
            "v": 1
          },
          {
            "f": "carrierDist",
            "op": "<",
            "v": 12
          },
          {
            "f": "carrierDistToOurGoal",
            "op": ">",
            "v": 40
          }
        ]
      },
      "cues": [
        "Can you press without opening the middle?",
        "Which pass do they want?",
        "Are teammates pressing with you?"
      ],
      "actions": [
        {
          "id": "press",
          "label": "Press the carrier",
          "intent": "press",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 8
                }
              ],
              "add": 0.3,
              "why": "you can reach them"
            },
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.4,
              "why": "a teammate is already on them"
            },
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "you are the first defender"
            },
            {
              "when": [
                {
                  "f": "carrierDistToOurGoal",
                  "op": "<",
                  "v": 20
                }
              ],
              "add": 0.2,
              "why": "they are close to our goal"
            }
          ]
        },
        {
          "id": "screen_lane",
          "label": "Screen the passing lane",
          "intent": "screen_lane",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "teammatePressing",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "the carrier is pressed: cut the outlet"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 5
                }
              ],
              "add": -0.2,
              "why": "you were close enough to press yourself"
            }
          ]
        },
        {
          "id": "delay",
          "label": "Delay, stay goal-side",
          "intent": "delay",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "firstDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.2,
              "why": "you are the nearest defender"
            },
            {
              "when": [
                {
                  "f": "oppRunnerNear",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "runners behind you: slow them, do not dive in"
            },
            {
              "when": [
                {
                  "f": "carrierDist",
                  "op": "<",
                  "v": 4
                }
              ],
              "add": 0.2,
              "why": "close enough to slow them down"
            },
            {
              "when": [
                {
                  "f": "secondDefender",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "someone else is first: your job is cover"
            }
          ]
        }
      ],
      "mistakes": [
        "Pressing alone",
        "Standing off a comfortable carrier"
      ],
      "difficultyFactors": [
        "Team pressing",
        "Carrier composure"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Ball won high, lane cut, or possession continues.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "theirPossession": 1,
              "carrierDist": 8,
              "carrierDistToOurGoal": 55
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "theirPossession": 1,
              "carrierDist": 8,
              "carrierDistToOurGoal": 20
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    },
    {
      "id": "ST_TRANS_01",
      "role": "ST",
      "category": "transition",
      "phase": "transition",
      "title": "Won it high",
      "trigger": {
        "all": [
          {
            "f": "hasBall",
            "op": "==",
            "v": 1
          },
          {
            "f": "secondsSinceTurnover",
            "op": "<",
            "v": 3
          },
          {
            "f": "distToGoal",
            "op": "<",
            "v": 30
          }
        ]
      },
      "cues": [
        "Is the keeper set?",
        "Is the shot open?",
        "Is a teammate better placed?"
      ],
      "actions": [
        {
          "id": "shoot",
          "label": "Shoot",
          "intent": "shoot",
          "base": 0.3,
          "eval": [
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": 0.6,
              "why": "the goal is open"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": "<",
                  "v": 14
                }
              ],
              "add": 0.4,
              "why": "close range"
            },
            {
              "when": [
                {
                  "f": "distToGoal",
                  "op": ">",
                  "v": 22
                }
              ],
              "add": -0.4,
              "why": "long range: low chance"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": "<",
                  "v": 0.15
                }
              ],
              "add": -0.5,
              "why": "the shooting lane is blocked"
            }
          ]
        },
        {
          "id": "attack_space",
          "label": "Attack the space",
          "intent": "attack_space",
          "base": 0.6,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceAhead",
                  "op": ">",
                  "v": 0.5
                }
              ],
              "add": 0.5,
              "why": "open space ahead of you"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.3,
              "why": "a defender is closing you down"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 2
                }
              ],
              "add": -0.1,
              "why": "teammates were open further up"
            }
          ]
        },
        {
          "id": "through_gap",
          "label": "Play through the gap",
          "intent": "through_gap",
          "base": 0.5,
          "eval": [
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": 0.4,
              "why": "a forward lane is open"
            },
            {
              "when": [
                {
                  "f": "teammateRunAhead",
                  "op": "==",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "a runner is timing a run"
            },
            {
              "when": [
                {
                  "f": "bestPassScore",
                  "op": ">",
                  "v": 1
                }
              ],
              "add": 0.3,
              "why": "the forward pass is on"
            }
          ]
        },
        {
          "id": "lay_off",
          "label": "Lay it off to the arriving teammate",
          "intent": "recycle",
          "base": 0.4,
          "eval": [
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.4,
              "why": "marked from behind: the first-time lay-off keeps it"
            },
            {
              "when": [
                {
                  "f": "shotWindow",
                  "op": ">",
                  "v": 0.35
                }
              ],
              "add": -0.4,
              "why": "the shot was open"
            },
            {
              "when": [
                {
                  "f": "progressiveLanes",
                  "op": ">=",
                  "v": 1
                }
              ],
              "add": -0.2,
              "why": "a forward option was on"
            },
            {
              "when": [
                {
                  "f": "openLanes",
                  "op": "==",
                  "v": 0
                }
              ],
              "add": -0.3,
              "why": "nobody had arrived to receive it"
            }
          ]
        },
        {
          "id": "switch_play",
          "label": "Switch the point of attack",
          "intent": "switch_play",
          "base": 0.35,
          "eval": [
            {
              "when": [
                {
                  "f": "spaceFarSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": 0.6,
              "why": "the far side is open"
            },
            {
              "when": [
                {
                  "f": "spaceNearSide",
                  "op": ">",
                  "v": 0.6
                }
              ],
              "add": -0.3,
              "why": "space near you is just as good, no need to switch"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.7
                }
              ],
              "add": -0.2,
              "why": "a long switch under pressure is risky"
            },
            {
              "when": [
                {
                  "f": "pressure",
                  "op": ">",
                  "v": 0.5
                },
                {
                  "f": "spaceNearSide",
                  "op": "<",
                  "v": 0.4
                }
              ],
              "add": 0.3,
              "why": "your side is overloaded: the spare player is on the far side"
            }
          ]
        }
      ],
      "mistakes": [
        "Panicking the shot",
        "Extra touch that lets the defence recover"
      ],
      "difficultyFactors": [
        "Keeper position",
        "Recovering defenders"
      ],
      "restrictions": {
        "ageGroups": [
          "U11",
          "U12"
        ]
      },
      "continuation": "Shot or quick attack.",
      "tests": {
        "positive": [
          {
            "label": "typical",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 1,
              "distToGoal": 20
            }
          }
        ],
        "negative": [
          {
            "label": "not eligible",
            "read": {
              "hasBall": 1,
              "secondsSinceTurnover": 20,
              "distToGoal": 20
            }
          }
        ]
      },
      "review": {
        "status": "provisional",
        "note": "Prototype content, not coach-reviewed."
      }
    }
  ]
}
